import request from './financeRequest'

export const transactionApi = {
  list: (params) => request.get('/finance/transactions', { params }),
  preview: (data) => request.post('/finance/transactions/preview', data),
  commission: (legacyId) =>
    request.get(`/finance/transactions/${legacyId}/commission`),
  prepare: (legacyId, data) =>
    request.post(`/finance/transactions/${legacyId}/prepare`, data),
  confirm: (id) => request.post(`/finance/transactions/${id}/confirm`),
  void: (id, data) => request.post(`/finance/transactions/${id}/void`, data),
}
